'use strict';

module.exports.GUI = require('./visualizer/annotations');
module.exports.Ranges = require('./range/Ranges');



// WEBPACK FOOTER //
// ./node_modules/spectra-data-ranges/src/index.js